import { Avatar, Box, Card, Stack, Typography } from '@mui/material';
import React from 'react';
import { BLUE_COLOR } from '../../../../constants/ColorsConst';
import { getFilesArchivos } from '../../../archivos/HelpersArchivos';

const CardDocenteComponent = ({ data, mini = false, onClick, select }) => {
  if (!data) return <div></div>;

  const cardMini = (
    <Card
      sx={{
        backgroundColor: select ? BLUE_COLOR : '#f4f4f4',
        mb: 1.5,
        p: 1,
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#aaaaaa',
        },
      }}
      onClick={onClick}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
        }}
      >
        <Avatar
          alt={data.usuario.perfil.pnombre}
          src={
            data.usuario.perfil.avatar
              ? getFilesArchivos(data.usuario.perfil.avatar)
              : `static/images/${
                  data.usuario.perfil.gender ? 'userf.png' : 'userm.png'
                }`
          }
          sx={{ width: 70, height: 70, mr: 1 }}
        />
        <Stack direction="column">
          <Typography
            sx={{
              fontWeight: 'bold',
              color: select ? 'white' : 'black',
            }}
          >
            {data.usuario.perfil.pnombre} {data.usuario.perfil.papellido}
          </Typography>
          <Typography
            sx={{
              fontWeight: 'bold',
              color: select ? 'white' : 'black',
            }}
          >
            {data.usuario.perfil.tipoDni}-{data.usuario.perfil.dni}
          </Typography>
        </Stack>
      </Box>
    </Card>
  );

  const cardMax = (
    <Card
      sx={{
        backgroundColor: select ? BLUE_COLOR : '#f4f4f4',
        mb: 1,
        p: 1,
        '&:hover': {
          cursor: 'pointer',
          backgroundColor: '#aaaaaa',
        },
      }}
      onClick={onclick}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <Avatar
          alt={data.usuario.perfil.pnombre}
          src={
            data.usuario.perfil.avatar
              ? getFilesArchivos(data.usuario.perfil.avatar)
              : `static/images/${
                  data.usuario.perfil.gender ? 'userf.png' : 'userm.png'
                }`
          }
          sx={{ width: 140, height: 140 }}
        />
        <Stack direction="column">
          <Typography
            align="center"
            sx={{
              fontSize: 18,
              fontWeight: 'bold',
              color: select ? 'white' : 'black',
            }}
          >
            {data.usuario.perfil.pnombre} {data.usuario.perfil.papellido}
          </Typography>
          <Typography
            align="center"
            sx={{
              fontSize: 14,
              fontWeight: 'bold',
              color: select ? 'white' : 'black',
            }}
          >
            {data.usuario.perfil.tipoDni}-{data.usuario.perfil.dni}
          </Typography>
        </Stack>
      </Box>
    </Card>
  );

  return mini ? cardMini : cardMax;
};

export default CardDocenteComponent;
